import React from 'react';
import { Box, Typography, LinearProgress, Chip } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';

/**
 * FrequencyCell Component
 * Compact visualization for table showing case coverage and station count
 *
 * @param {object} props
 * @param {number} props.caseCoverage - Percentage of cases (0-100)
 * @param {number} props.stationCount - Number of stations
 */
const FrequencyCell = ({ caseCoverage = 0, stationCount = 0 }) => {
  return (
    <Box sx={{ minWidth: 160 }}>
      {/* Case Coverage Bar */}
      <Box sx={{ mb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.3 }}>
          <PeopleIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
          <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.7rem' }}>
            Fälle
          </Typography>
          <Typography variant="caption" fontWeight="bold" sx={{ ml: 'auto', fontSize: '0.75rem' }}>
            {caseCoverage}%
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={caseCoverage}
          sx={{
            height: 6,
            borderRadius: 1,
            backgroundColor: '#e0e0e0',
            '& .MuiLinearProgress-bar': {
              backgroundColor: caseCoverage >= 70 ? '#4caf50' : caseCoverage >= 40 ? '#ff9800' : '#2196f3',
              borderRadius: 1
            }
          }}
        />
      </Box>

      {/* Station Count */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <BusinessIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
        <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.7rem' }}>
          Stationen
        </Typography>
        <Chip
          label={stationCount}
          size="small"
          sx={{
            ml: 'auto',
            height: 18,
            fontSize: '0.7rem',
            fontWeight: 'bold',
            backgroundColor: stationCount >= 10 ? '#e8f5e9' : stationCount >= 5 ? '#fff3e0' : '#e3f2fd',
            color: stationCount >= 10 ? '#2e7d32' : stationCount >= 5 ? '#e65100' : '#1565c0'
          }}
        />
      </Box>
    </Box>
  );
};

export default FrequencyCell;
